import React from "react";
import cloneDeep from "lodash/cloneDeep";
import { Col, ControlLabel, FormGroup, HelpBlock, Row } from "components/bootstrap";
import { Select } from "components/common";
import AggregationConditionExpression from "../AggregationConditionExpression";
const ComparisonExpression = ({
  expression,
  level,
  onChildChange,
  onChange,
  renderLabel,
  validation = {},
  ...props
}) => {
  const handleExpressionOperatorChange = (nextOperator) => {
    const nextExpression = cloneDeep(expression);
    nextExpression.expr = nextOperator;
    onChange({ conditions: nextExpression });
  };
  return /* @__PURE__ */ React.createElement(Col, { md: 10 }, /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, /* @__PURE__ */ React.createElement(
    AggregationConditionExpression,
    {
      ...props,
      expression: expression.left,
      validation: validation.left,
      parent: expression,
      onChange: onChildChange("left"),
      level: level + 1
    }
  ), /* @__PURE__ */ React.createElement(Col, { md: 3 }, /* @__PURE__ */ React.createElement(FormGroup, { controlId: "aggregation-condition", validationState: validation.message ? "error" : null }, renderLabel && /* @__PURE__ */ React.createElement(ControlLabel, null, "Is"), /* @__PURE__ */ React.createElement(
    Select,
    {
      id: "aggregation-condition",
      placeholder: "Select Condition",
      onChange: handleExpressionOperatorChange,
      options: [
        { label: "<", value: "<" },
        { label: "<=", value: "<=" },
        { label: ">", value: ">" },
        { label: ">=", value: ">=" },
        { label: "=", value: "==" }
      ],
      value: expression.expr,
      clearable: false
    }
  ), validation.message && /* @__PURE__ */ React.createElement(HelpBlock, null, validation.message))), /* @__PURE__ */ React.createElement(
    AggregationConditionExpression,
    {
      ...props,
      expression: expression.right,
      validation: validation.right,
      parent: expression,
      onChange: onChildChange("right"),
      level: level + 1
    }
  )));
};
export default ComparisonExpression;
